
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zm0 2C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14z"}}),_c('path',{attrs:{"d":"M19.092 8.017c.177-.386-.132-2.067-1.037-4.69l1.89-.653c1.095 3.173 1.453 5.116.963 6.179-.35.763-1.357 2.585-3.041 5.515a1 1 0 0 1-.867.502h-1.561L14 16.434v2.48l.736.8a1 1 0 0 1 .172 1.095l-.546 1.187 1.9.691 4 1.087a1 1 0 0 1 .738.965V28h-2v-2.497l-3.34-.91-3-1.088a1 1 0 0 1-.568-1.358l.721-1.569-.549-.597a1 1 0 0 1-.264-.677v-3.26a1 1 0 0 1 .264-.678l2-2.173A1 1 0 0 1 15 12.87h1.421c1.477-2.577 2.374-4.209 2.67-4.853zM9 18.535l-2.555-1.703-.152-.125-2-2a1 1 0 0 1-.242-.39l-1-3a1 1 0 0 1 1.898-.633l.925 2.776 1.763 1.763 2.918 1.945A1 1 0 0 1 11 18v2a1 1 0 0 1-.051.316l-1 3a1 1 0 0 1-.242.391l-2 2a1 1 0 1 1-1.414-1.414l1.833-1.833L9 19.838v-1.303zM27 15.697l1.832 2.748a1 1 0 1 1-1.664 1.11l-2-3A1 1 0 0 1 25 16v-2a1 1 0 0 1 .051-.316l1-3a1 1 0 0 1 1.898.632L27 14.162v1.535z"}})])])
          )
        }
      }
    